export const goToContractStep = (history, match, newStep) => {
  history.push(`${match.url}/${newStep.id}`);
};
